import {Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren} from "@angular/core";
import {DOCUMENT_TYPES, VALUE_TYPE} from "../../enums/enums";
import {PreloaderService} from "../../services/preloader.service";
import {Http, Response, Headers} from "@angular/http";
import {ErrorService} from "../../services/error.service";
import {Observable} from "rxjs/Observable";
import * as _ from "underscore";
import {CollectionService} from "../../services/collection.service";
import {FileLikeObject, FileUploader} from 'ng2-file-upload';
import {NvFileUploader} from "../../classes/nv-file-uploader/nv-file-uploader.class";
import {LockService} from "../../services/lock.service";
import {LoaderService} from "../../services/loader.service";
import {paramsHelper} from "../../helpers/params-helper";
import {E_ENDPOINTS} from "../../helpers/params/loader-params";
import {IDocument} from "../../interfaces/document.definition";
import {ModalService} from "../../services/modal.service";
import {HistoryService} from "../../services/history.service";
//import {timeout} from "rxjs/operators";
import 'rxjs/add/operator/timeout';

import {delay, first, repeat, switchMapTo, takeUntil, timeout} from "rxjs/operators";
import {Subject} from "rxjs/Subject";
import {of} from "rxjs/observable/of";
import {timer} from "rxjs/observable/timer";


declare const __mongos: string[];
declare const __metaOut: string[];
declare const __metaIn: any;
declare const __ubs: any;


@Component({
  templateUrl: "./home-page.component.html",
})
export class HomePageComponent implements OnInit {
  selectedLocale: string;
  VALUE_TYPE = VALUE_TYPE;
  MONGO_CONFIGS = _.map(__mongos, (v: string) => ({ id: v, label: v }));
  META_OUT_NAMES = __metaOut;
  META_IN = __metaIn;
  UBS = __ubs;

  loadedLocales: any[] = [];
  resources = {
    params: {},
    result: "",
  };

  meta = { result: "" };

  // uploader = new FileUploader({
  uploader = new NvFileUploader({
    url: "/meta/upload-xlsx",
    removeAfterUpload: true,
    queueLimit: 1,
    filters: [
      {
        name: "filename-filter",
        fn: (file: FileLikeObject): boolean => {
          return /\.xlsx$/.test(file ? file.name : "");
        },
      },
    ],
    additionalParameter: { locale: "en" },
  });

  @ViewChild("uploaderInput") uploaderInput: ElementRef;

  public hasBaseDropZoneOver: boolean = false;

  constructor(
    private http: Http,
    private preloaderService: PreloaderService,
    private errorService: ErrorService,
    private collectionService: CollectionService,
    private modalService: ModalService,
    private historyService: HistoryService
  ) {}

  ngOnInit(): void {
    this.loadLocalesList();
    this.uploader.onComplete.subscribe((): void => this.onUploaderComplete());
    // todo: subscribe

    this.uploader.onError.subscribe((response: string): void => this.onUploaderError(response));
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  onUploadAllClick() {
    this.uploader.options.additionalParameter = { locale: this.selectedLocale };
    this.uploader.uploadAll();
    this.preloaderService.show();
  }

  onClearQueueClick() {
    this.uploader.clearQueue();
    this.clearInputField();
  }

  onExportToGameFileClick(metaOutName: string) {
    this.modalService.showHistoryJournal();
  }

  onGetForUBSClick() {
    window.location.href = "/ubs/get";
    window.location.href = "/ubs/get";
    window.location.href = "/ubs/get";
  }

  onSendToUBSClick(config: object) {
    this.modalService.showConfirm("Точно выгружаем данные в UBS?", this.onSendToUBSClickConfirmed.bind(this, config));
  }

  onSendToUBSClickConfirmed(config: object) {
    console.log(JSON.stringify(config));
    this.preloaderService.show();
    this.sendData("/ubs/send", { config }).subscribe((response) => {
      console.log(`send to ubs ${JSON.stringify(response)}`);
      this.preloaderService.hide();
    });
  }

  onLoadMetaObjectsClick(name: string): void {
    this.modalService.showMetaImportPopup(name);
    /*this.preloaderService.show();

    this.sendData("/meta/import-meta-objects", {name:name, query:[{type:"quest", id:10}, {type:"offer", id:1}]})
      .subscribe(json => {
        this.preloaderService.hide();
        console.log(json);
      });*/
  }

  onLoadMetaClick(uri: string): void {
    this.preloaderService.show();

    this.sendData("/meta/import-all-meta", { uri: uri })
      //.timeout(1000 * 60 * 120)
      .subscribe((json) => {
        this.preloaderService.hide();
        this.meta.result = json;
        this.historyService.clearHistory().subscribe(() => console.log("history cleared"));
      });
  }

  onLocaleChange(event) {
    this.selectedLocale = event;
    //localeUtils.setLocale(event);
  }

  onCheckLocaleClick() {
    this.preloaderService.show();
    console.log(`try check ${this.selectedLocale}`);
    this.sendData("/meta/check-locale", { locale: this.selectedLocale }).subscribe((result) => {
      this.preloaderService.hide();

      var msg = `Незаполненные локали (${result.length}):`;
      for (let i = 0; i < result.length; i++) {
        msg += `\n${result[i]};`;
      }
      this.modalService.showMessage(msg);
    });
  }

  onDownloadXlsClick() {
    window.location.href = `/meta/dump-locales-to-xlsx?locale=${this.selectedLocale}`;
  }

  onRefreshAssets() {
    this.modalService.showConfirm(
      "Точно обновляем из гита? Это затрет невыгруженные изменения в ассетах",
      this.onRefreshAssetsConfirmed.bind(this)
    );
  }

  onRefreshAssetsConfirmed() {
    this.preloaderService.show();
    console.log("refresh assets");
    this.sendData("/animations/refresh-assets", {}).subscribe((result) => {
      this.preloaderService.hide();
    });
  }

  private sendData(uri: string, data: any = null): Observable<any> {
    //let headers = new Headers({'Content-Type': 'application/json', 'Keep-Alive': 'timeout=7200'});
    return (
      this.http
        .post(uri, data /*, {headers: headers}*/)
        //.pipe(timeout(1000 * 60 * 1200))
        //.timeout(1000 * 60 * 1200)
        .map((r: Response) => {
          let j = null;
          try {
            j = r.arrayBuffer().byteLength > 0 ? r.json() : {};
          } catch (e) {
            console.log(e);
            j = {};
          }
          return j;
        })
        .catch((e) => {
          console.log(e);
          return this.errorService.handleError(e);
        })
    );
  }

  private loadLocalesList() {
    const params = paramsHelper.loader().setEndpointApi().setObjectType(DOCUMENT_TYPES.LOCALE).setNavParams(0, 9999);

    this.collectionService.loadChunkCached(params).subscribe((r) => {
      this.loadedLocales = r.documents;
      this.loadedLocales = this.loadedLocales.filter((loc) => loc.disabled != true);
      this.selectedLocale = this.loadedLocales[0].lang;
      //console.log(`load locales list ${this.loadedLocales}`);
    });
  }

  private onUploaderComplete() {
    this.preloaderService.hide();
    this.clearInputField();
  }

  private clearInputField() {
    this.uploaderInput.nativeElement.value = "";
  }

  private onUploaderError(response: string) {
    this.errorService.handleError(new Error(`Upload error: ${response}`));
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/home/home-page.component.ts